import React, {useState} from 'react';
import * as Yup from 'yup';
import {Formik} from "formik";
import {FormGroup, Input, Label, Button, Alert} from "reactstrap";
import {isUserAuthenticated, setToken} from "../services/auth";
import api from "../services/api";
import {useHistory, Redirect, Link} from "react-router-dom";
import {receiveUser} from "../redux/auth/actions";
import {useDispatch, useSelector} from "react-redux";

const Login = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const school = useSelector(state => state.school);
    const [showAlert, setShowAlert] = useState(false);

    const initialValues = {
        email: "",
        password: ""
    };

    const ValidationSchema = Yup.object().shape({
        email: Yup.string().required(),
        password: Yup.string().required()
    });

    const onSubmit = (values, setSubmitting) => {
        setShowAlert(false);

        const {email, password} = values;

        api.login(email, password).then(response => {
            setToken(response.data.access_token);

            api.fetchMe().then(response => {
                dispatch(receiveUser(response.data.data));
                history.replace('/enrollment');
            });
        }).catch(() => {
            setShowAlert(true);
            setSubmitting(false);
        })
    };

    if (isUserAuthenticated()) {
        return <Redirect to="/enrollment"/>
    }

    return (
        <React.Fragment>
            <div
                className="elementor-element elementor-element-1fb6e55c elementor-widget elementor-widget-heading animated fadeIn"
                data-id="1fb6e55c" data-element_type="widget"
                data-settings="{&quot;_animation&quot;:&quot;fadeIn&quot;}" data-widget_type="heading.default"
            >
                <div className="elementor-widget-container">
                    <h3 className="elementor-heading-title elementor-size-large">
                        {!!school.is_association ? 'Login to My Account' : 'Existing Student'}
                    </h3>
                </div>
            </div>

            <div className="elementor-widget-container">
                <div className="elementor-divider">
                    <span className="elementor-divider-separator"/>
                </div>
            </div>

            <Alert isOpen={showAlert} color="danger">
                Email and password doesn't match any of our records.
            </Alert>

            <Formik
                initialValues={initialValues}
                validationSchema={ValidationSchema}
                onSubmit={(values, {setSubmitting}) => onSubmit(values, setSubmitting)}
            >
                {(
                    {values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting}
                ) => (
                    <form onSubmit={handleSubmit} className="mb-3">
                        <FormGroup>
                            <Label for="email">Email</Label>
                            <Input type="email" name="email" id="email"
                                   onChange={handleChange}
                                   onBlur={handleBlur}
                                   value={values.email}
                                   invalid={!!(errors.email && touched.email && errors.email)}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label for="login-password">Password</Label>
                            <Input type="password" name="password" id="login-password"
                                   onChange={handleChange}
                                   onBlur={handleBlur}
                                   value={values.password}
                                   invalid={!!(errors.password && touched.password && errors.password)}
                            />
                        </FormGroup>

                        <Button type="submit" disabled={isSubmitting} className="elementor-button mb-3">
                            Submit
                        </Button>

                        <p>
                            <Link to="/forget-password">
                                Forgot your password?
                            </Link>
                        </p>
                    </form>
                )}
            </Formik>
        </React.Fragment>
    );
};

export default Login;
